// EVO i18n architecture. English is the source of truth and fully populated.
// Other languages are intentionally left as empty scaffolds — professional
// translations are added later (Phase 2). Missing keys fall back to English,
// so the UI is never broken while translations are in progress.

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN", dir: "ltr" },
  { code: "it", label: "Italiano", short: "IT", dir: "ltr" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
  { code: "zh", label: "中文", short: "ZH", dir: "ltr" },
  { code: "ru", label: "Русский", short: "RU", dir: "ltr" },
];

export const translations = {
  en: {
    nav: { home: "Home", services: "Services", staffing: "Staffing", portfolio: "Portfolio", about: "About", contact: "Contact" },
    common: { requestQuote: "Request Quote", requestQuotation: "Request a Quotation" },
  },
  // Phase 2 — add translated keys mirroring the `en` structure.
  it: {},
  ar: {},
  zh: {},
  ru: {},
};
